import { getShippingEstimateQuantityInSeconds as _getShippingEstimateQuantityInSeconds } from '@vtex/estimate-calculator'

import type { Package } from '../../../../../core/typings'
import { normalizeProductPrice } from '../../../../../core/utils/product'

const getShippingEstimateQuantityInSeconds = (value: string | null) => {
  return value ? _getShippingEstimateQuantityInSeconds(value) : Infinity
}

// TODO: remove duplication with src/screens/NewProductPage/components/ProductSkuAvailability/ProductSkuAvailabilityDelivery.tsx
export const decorateDeliverySlaWithBestIndicators = (
  currentPackage: Package,
  currentSla: SLA
) => {
  const deliverySlas = currentPackage.slas.filter(
    (sla) => sla.deliveryChannel === 'delivery'
  )

  const cheapestDeliveryPrice = Math.min(
    ...deliverySlas.map((sla) => sla.price ?? Infinity)
  )

  const cheapestDeliverySlas = deliverySlas.filter(
    (sla) => sla.price === cheapestDeliveryPrice
  )

  const bestCheapestDeliverySla = cheapestDeliverySlas.reduce(
    (acc, current) => {
      const isFaster =
        getShippingEstimateQuantityInSeconds(current.shippingEstimate) <
        getShippingEstimateQuantityInSeconds(acc.shippingEstimate)

      return isFaster ? current : acc
    },
    cheapestDeliverySlas[0]
  )

  const fatestDeliveryValue = Math.min(
    ...deliverySlas.map((sla) =>
      getShippingEstimateQuantityInSeconds(sla.shippingEstimate)
    )
  )

  const fatestDeliverySlas = deliverySlas.filter(
    (sla) =>
      getShippingEstimateQuantityInSeconds(sla.shippingEstimate) ===
      fatestDeliveryValue
  )

  const bestFatestDeliverySla = fatestDeliverySlas.reduce((acc, current) => {
    const isCheaper =
      normalizeProductPrice(current.price) < normalizeProductPrice(acc.price)

    return isCheaper ? current : acc
  }, fatestDeliverySlas[0])

  return {
    ...currentSla,
    isCheapest: bestCheapestDeliverySla?.id === currentSla.id,
    isFatest: bestFatestDeliverySla?.id === currentSla.id,
  }
}
